module.exports = __webpack_public_path__ + "static/img/6.f626b6b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/eng/6.png
// module id = jUkt
// module chunks = 0